'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconBlock = function IconBlock(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ fill: 'none', height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement(
      'g',
      { fill: color },
      _react2.default.createElement('path', { d: 'M11.8083333,3.66666667 C7.31666667,3.66666667 3.66666667,7.32083333 3.66666667,11.8125 C3.66666667,13.9891667 4.50833333,16.0358333 6.05,17.575 C7.59166667,19.1141667 9.63333333,19.9625 11.8083333,19.9625 C16.3083333,19.9625 19.9583333,16.3066667 19.9583333,11.8125 C19.9583333,7.32083333 16.3083333,3.66666667 11.8083333,3.66666667 Z M11.8083333,21.6291667 C9.19166667,21.6291667 6.725,20.6075 4.875,18.7533333 C3.01666667,16.8991667 2,14.4341667 2,11.8125 C2,6.40166667 6.4,2 11.8083333,2 C17.225,2 21.625,6.40166667 21.625,11.8125 C21.625,17.2258333 17.225,21.6291667 11.8083333,21.6291667 L11.8083333,21.6291667 Z' }),
      ' ',
      _react2.default.createElement('path', { d: 'M18.1583333,18.9933333 C17.9416667,18.9933333 17.7333333,18.9116667 17.5666667,18.7491667 L4.9,6.08083333 C4.575,5.755 4.575,5.2275 4.9,4.90166667 C5.225,4.57666667 5.75,4.57666667 6.075,4.90166667 L18.75,17.5708333 C19.075,17.8958333 19.075,18.4233333 18.75,18.7491667 C18.5833333,18.9116667 18.375,18.9933333 18.1583333,18.9933333' }),
      ' ',
      _react2.default.createElement('path', { d: 'M5.49166667,18.9933333 C5.275,18.9933333 5.05833333,18.9116667 4.9,18.7491667 C4.575,18.4233333 4.575,17.8958333 4.9,17.5708333 L17.5666667,4.90166667 C17.8916667,4.57666667 18.425,4.57666667 18.75,4.90166667 C19.075,5.2275 19.075,5.755 18.75,6.08083333 L6.075,18.7491667 C5.91666667,18.9116667 5.7,18.9933333 5.49166667,18.9933333' }),
      ' '
    )
  );
};

IconBlock.propTypes = {
  color: _propTypes2.default.string
};

IconBlock.defaultProps = {
  color: _colors2.default.icons
};

IconBlock.displayName = 'IconBlock';

exports.default = IconBlock;
module.exports = exports.default;